// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n*[data-v-86c531a8] {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\nbody[data-v-86c531a8] {\n  overflow: hidden;\n}\n.wrapper[data-v-86c531a8] {\n  display: flex;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
